/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorAvailability from './doctor-availability';
import DoctorAvailabilityDetail from './doctor-availability-detail';
import DoctorAvailabilityUpdate from './doctor-availability-update';
import DoctorAvailabilityDeleteDialog from './doctor-availability-delete-dialog';

const DoctorAvailabilityRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorAvailability />} />
    <Route path="new" element={<DoctorAvailabilityUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorAvailabilityDetail />} />
      <Route path="edit" element={<DoctorAvailabilityUpdate />} />
      <Route path="delete" element={<DoctorAvailabilityDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorAvailabilityRoutes;
